import React from "react";
import {Card, Col, Row, Tooltip, Typography} from 'antd';
import {EditOutlined, InfoCircleOutlined} from '@ant-design/icons';
import PropTypes from "prop-types";

import ErrorBoundary from '../ErrorBoundary';
import {GSTRegistrationNumberText, TaxRegistrationNumberText} from '../../helpers/text';
import {useGetCompanyInfoQuery} from "../../store/api/settingsApi";

const {Text} = Typography;

const AccountBusinessDetailsStaff = ({companyData, onEdit}) => {
    const {data: companyInfo} = useGetCompanyInfoQuery();
    const clientCountry = companyInfo.country;

    const taxNumberText = clientCountry === 'CA' ? GSTRegistrationNumberText : TaxRegistrationNumberText;

    return (
        <Card
            title={<><span>Business Details</span></>}
            extra={
                <EditOutlined key="edit" onClick={onEdit}/>
            }
            className="business-details-card"
        >
            <ErrorBoundary>
                <Row>
                    <Col span={24}>
                        <span><Text strong>Business Name:</Text></span>
                    </Col>
                    <Col span={24}>
                        <span>{companyData.business_name ? companyData.business_name : 'N/A'}</span>
                    </Col>
                </Row>
                <Row>
                    <Col span={24}>
                        <span><Text strong>DBA Name:</Text></span>
                    </Col>
                    <Col span={24}>
                        <span>{companyData.dba_name ? companyData.dba_name : 'N/A'}</span>
                    </Col>
                </Row>
                <Row>
                    <Col span={24}>
                        <span><Text strong>Name on Contract:</Text></span>
                    </Col>
                    <Col span={24}>
                        <span>{companyData.name_on_contract ? companyData.name_on_contract : 'N/A'}</span>
                    </Col>
                </Row>
                <Row>
                    <Col span={24}>
                        <span><Text strong>{taxNumberText}:</Text></span>
                    </Col>
                    <Col span={24}>
                        <span>{companyData.gst_hst_number ? companyData.gst_hst_number : 'N/A'}</span>
                    </Col>
                </Row>
                <Row>
                    <Col span={24}>
                        <span><Text strong>Business Registration Number:</Text></span>
                    </Col>
                    <Col span={24}>
                        <span>{companyData.business_registration_number ?
                            companyData.business_registration_number : 'N/A'}</span>
                    </Col>
                </Row>
                <Row>
                    <Col span={24}>
                        <span><Text strong>Website Address:</Text></span>
                    </Col>
                    <Col span={24}>
                        {
                            companyData.website_address ?
                                <Text className="long-text-wrap">{companyData.website_address}</Text>
                                :
                                'N/A'
                        }
                    </Col>
                </Row>
                <Row>
                    <Col span={24}>
                        <span><Text strong>Industry Code:</Text></span>
                    </Col>
                    <Col span={24}>
                        <span>{companyData.industry_code ? companyData.industry_code : 'N/A'}</span>
                    </Col>
                </Row>
                <Row>
                    <Col span={24}>
                        <span><Text strong>Company Size:</Text></span>
                        <Tooltip title="The number of employees at the company.">
                            <InfoCircleOutlined/>
                        </Tooltip>
                    </Col>
                    <Col span={24}>
                        <span>{companyData.company_size ? companyData.company_size : 'N/A'}</span>
                    </Col>
                </Row>
            </ErrorBoundary>
        </Card>
    );
}

AccountBusinessDetailsStaff.propTypes = {
    companyData: PropTypes.object.isRequired,
    onEdit: PropTypes.func.isRequired,
};

export default AccountBusinessDetailsStaff;
